/*
 * DROP · panel "Filtrar y ordenar" con la experiencia de adidas.
 *  - Al abrir el panel quedan desplegados "Ordenar por" y "Talla" (si la persona no los cerró).
 *  - Cada acordeón con selección muestra "Título (n)" + lo elegido debajo y una barra negra a la izquierda.
 *  - "Filtros aplicados" (arriba del panel) se actualiza en vivo al marcar o quitar filtros, sin cerrar el panel.
 *  - El botón "Filtros" de la barra muestra cuántos filtros hay activos.
 * Los filtros se aplican al instante (assets/facets.js); este archivo solo ordena lo visual y mantiene el estado coherente.
 */
(function () {
  if (window.__dropFilterUx) return;
  window.__dropFilterUx = true;

  var DRAWER = '.drawer__content-facets';

  function all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- 1) secciones desplegadas por defecto ---------- */
  function openSection(d) {
    var body = d.querySelector('.accordion__body');
    var sum = d.querySelector('summary');
    if (!d.classList.contains('is-active')) d.classList.add('is-active');
    if (!d.hasAttribute('open')) d.setAttribute('open', '');
    if (body && !body.classList.contains('is-transitioning') && body.style.height !== 'auto') body.style.height = 'auto';
    if (sum && sum.getAttribute('aria-expanded') !== 'true') sum.setAttribute('aria-expanded', 'true');
  }

  function ensureOpen() {
    all(DRAWER + ' details.drop-sort, ' + DRAWER + ' details.drop-facet--size').forEach(function (d) {
      if (d.getAttribute('data-drop-closed') === '1') return;
      openSection(d);
    });
  }

  document.addEventListener('click', function (e) {
    var sum = e.target && e.target.closest ? e.target.closest(DRAWER + ' summary') : null;
    if (!sum) return;
    var d = sum.parentElement;
    if (!d || !(d.classList.contains('drop-sort') || d.classList.contains('drop-facet--size'))) return;
    /* accordion-default alterna la clase después de este evento: si hoy está activo, la persona lo va a cerrar */
    d.setAttribute('data-drop-closed', d.classList.contains('is-active') ? '1' : '0');
  }, true);

  /* ---------- 2) título (n) + selección debajo ---------- */
  function labelOf(input, d) {
    var id = input.id;
    var l = id ? d.querySelector('label.checkbox__label[for="' + id + '"]') : null;
    if (!l && id) l = d.querySelector('label[for="' + id + '"]');
    var t = l ? (l.textContent || '').replace(/\s+/g, ' ').trim() : String(input.value || '');
    return t;
  }

  function decorate() {
    var priceOn = /(^|[?&])filter\.v\.price\./.test(window.location.search);
    all(DRAWER + ' details.facets__accordion-section').forEach(function (d) {
      var sum = d.querySelector('summary');
      if (!sum || d.classList.contains('drop-sort')) return;
      var wrap = sum.querySelector('.drop-stw');
      if (!wrap) {
        var title = '';
        Array.prototype.slice.call(sum.childNodes).forEach(function (n) {
          if (n.nodeType === 3) { title += n.textContent; sum.removeChild(n); }
        });
        wrap = document.createElement('span');
        wrap.className = 'drop-stw';
        var st = document.createElement('span');
        st.className = 'drop-st';
        st.setAttribute('data-title', title.trim());
        st.textContent = title.trim();
        var sb = document.createElement('span');
        sb.className = 'drop-sub';
        wrap.appendChild(st);
        wrap.appendChild(sb);
        sum.insertBefore(wrap, sum.firstChild);
      }
      var st2 = wrap.querySelector('.drop-st');
      var sb2 = wrap.querySelector('.drop-sub');
      var names = all('input[type=checkbox]:checked', d).map(function (i) { return labelOf(i, d); });
      var isPrice = d.classList.contains('drop-facet--price');
      var n = isPrice ? (priceOn ? 1 : 0) : names.length;
      var sub = isPrice ? (priceOn ? 'Rango elegido' : '') : names.join(', ');
      var title2 = st2.getAttribute('data-title') + (n ? ' (' + n + ')' : '');
      if (st2.textContent !== title2) st2.textContent = title2;
      if (sb2.textContent !== sub) sb2.textContent = sub;
      d.classList.toggle('has-active', n > 0);
    });
  }

  /* ---------- 3) filtros aplicados en vivo + contador en el botón ---------- */
  function chipText(b) {
    var c = b.cloneNode(true);
    all('.visually-hidden, .svg-wrapper, label, svg, input', c).forEach(function (x) { x.parentNode.removeChild(x); });
    return (c.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function syncApplied() {
    var chips = all('.active-facets .active-facets__button').filter(function (b) {
      return !b.classList.contains('active-facets__vertical-filter');
    });
    var items = [];
    chips.forEach(function (b) {
      var a = b.querySelector('a[href]');
      if (!a) return;
      var t = chipText(b);
      if (t) items.push({ t: t, h: a.getAttribute('href') });
    });

    var box = document.querySelector('.drop-applied');
    var list = box ? box.querySelector('.drop-applied__list') : null;
    if (box && list) {
      var sig = items.map(function (i) { return i.t + '|' + i.h; }).join('\n');
      if (list.getAttribute('data-sig') !== sig) {
        list.setAttribute('data-sig', sig);
        list.innerHTML = items.map(function (i) {
          return '<facet-remove><a class="drop-chip" href="' + esc(i.h) + '">' + esc(i.t) + '</a></facet-remove>';
        }).join('');
      }
      box.classList.toggle('is-empty', items.length === 0);
    }

    all('.dcb__filtbtn, summary.facets__button-filters').forEach(function (btn) {
      var badge = btn.querySelector('.drop-fbadge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'drop-fbadge';
        btn.appendChild(badge);
      }
      var txt = items.length ? String(items.length) : '';
      if (badge.textContent !== txt) badge.textContent = txt;
      var disp = items.length ? '' : 'none';
      if (badge.style.display !== disp) badge.style.display = disp;
    });
  }

  /* total del pie: con filtros activos el texto "X de Y productos" trae X = resultados filtrados; sin filtros, Y = total */
  function syncTotal() {
    var src = document.getElementById('ProductCount');
    var dst = document.getElementById('DropFilterTotal');
    if (!src || !dst) return;
    var m = (src.textContent || '').match(/(\d+)\s*\D+\s*(\d+)/);
    var n;
    if (m) {
      var filtered = /[?&](filter\.|drop_t=|drop_s=)/.test(window.location.search);
      n = filtered ? m[1] : m[2];
    } else {
      var one = (src.textContent || '').match(/(\d+)/);
      n = one ? one[1] : '';
    }
    var txt = n ? n + (n === '1' ? ' artículo encontrado' : ' artículos encontrados') : '';
    if (dst.textContent !== txt) dst.textContent = txt;
  }

  function refresh() {
    ensureOpenIfDrawerOpen();
    decorate();
    syncApplied();
    syncTotal();
  }

  function drawerIsOpen() {
    var d = document.querySelector('details.drawer__container[open]');
    return !!(d && d.querySelector(DRAWER));
  }
  function ensureOpenIfDrawerOpen() {
    if (drawerIsOpen()) ensureOpen();
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 90);
  }

  function start() {
    refresh();
    new MutationObserver(function (records) {
      var relevant = records.some(function (r) {
        var t = r.target && r.target.nodeType === 1 ? r.target : r.target.parentElement;
        if (!t || !t.closest) return true;
        if (t.closest('summary') || t.closest('.drop-applied__list') || t.closest('.dcb__filtbtn') || t.closest('#DropFilterTotal')) return false;
        return true;
      });
      if (relevant) schedule();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'checked'] });
    /* al abrir el panel (animación) volvemos a asegurar las secciones desplegadas */
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('summary.facets__button-filters, .dcb__filtbtn')) {
        setTimeout(refresh, 60);
        setTimeout(refresh, 400);
      }
    });
    document.addEventListener('change', function () { setTimeout(refresh, 200); }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
